import * as React from "react"
import {IconSeeker} from "@ui-seeker/core";
import {Box} from "@mui/material";


export default function checkColumn(name, label) {
	return [{
		name, label,
		options: {
			display: 'excluded',
			customBodyRowRender: (value, dataRow) => {
				if (dataRow[`${name}_kpi`] === null)
					return 'N/A'
				return value ? 'Yes' : 'No'
			}
		}
	},{
		name, label,
		options: {
			filter: false,
			setCellHeaderProps: () => ({ sx: {
				whiteSpace: 'pre-wrap',
				minWidth: 160
			}}),
			customBodyRowRender: (value, dataRow) => {
				let valueKpi = dataRow[`${name}_kpi`]
				let color = 'text.disabled'
				let icon = 'square-minus'

				if (valueKpi !== null) {
					color = value ? 'success.lighter' : 'error.lighter'
					icon = value ? 'square-check' : 'square-xmark'
				}

				return <Box sx={{ textAlign: 'center', fontSize: 21 }}>
					<IconSeeker icon={icon} sx={{ color: color }}/>
			</Box>}
		}
	}]
}